import * as projMsgs from "../../../app/msg/projMsgs";
import { AppConfig } from '@core_n/app.config';

export class MsgMngr {

  private _address: string;
  private _wsMode: string = "ws";
  private _retryCount: number = 0;
  protected server: string;
  protected socket: WebSocket = null;
  protected connected = false;
  protected interval: any = undefined;
  
  constructor() { }

  setAddress(host: string) {
    this._address = host;
  }

  get hostname() {
    return this._address;
  }

  async openWebSocket(retry: boolean = false, tmp: boolean = false) {
    if (this._address == undefined) {
      // this._hostname = self.location.hostname;
      // this._hostname = "localhost";
      this._address = AppConfig.settings.backendAddress.address;
      this._wsMode = AppConfig.settings.backendAddress.wsMode;
      this._retryCount = AppConfig.settings.backendAddress.retryCount;

      let localIp = await this.ipLocal();
      let localIpStr: string = localIp.toString();
      if (!localIpStr.endsWith('.local')) {
        if (this._address != localIpStr) {
          console.log('Web socket opening at', localIpStr);
          this._address = localIpStr;
        }
      }
    }

    if (this.socket && this.connected) {
      return;
    }

    this.connected = false;
    this.server = this._wsMode + `://${this._address}`;
    console.log("opening connection on: " + this.server);

    this.socket = new WebSocket(this.server);
    this.socket.onopen = this.onOpen.bind(this);
    this.socket.onmessage = this.onMessage.bind(this);
    if (!retry) {
      this.socket.onclose = this.onClose.bind(this);
      this.socket.onerror = this.onError.bind(this);
    }
  }

  close() {
    if (this.connected) {
      this.socket.close();
      this.socket = null;
      this.connected = false;
    }
  }

  initialized(): boolean {
    return this.socket != null;
  }

  connectionOpen(): boolean {
    return this.initialized() && this.socket.readyState == WebSocket.OPEN;
  }

  send(msgObj: any): void {
    this.socket.send(JSON.stringify(msgObj));
  }

  protected onOpen() {
    console.log(`Web server ${this.server} socket opened`);
    this.connected = true;
    if (this.interval)
      window.clearInterval(this.interval);
    this.socket.onclose = this.onClose.bind(this);
    this.socket.onerror = this.onError.bind(this);
    this.startUpSwa();
  }

  public startUpSwa() {
    this.send(new projMsgs.GetSensors());
    this.send(new projMsgs.GetTracks());
    // this.send(new projMsgs.GetClsArm());
    this.send(new projMsgs.ClientInit());
  }

  protected onClose() {
    this.connected = false;
    console.error(`Connection to Server: ${this.server} Closed`);
    let self = this;
    let counter = 1;
    let maxcount = this._retryCount;
    var interval = setInterval(function () {
      console.error(`Retrying Connection (Attempt ${counter}/${maxcount})`);
      self.openWebSocket(true, true);
      if (++counter > maxcount) {
        window.clearInterval(interval);
      }
    }, 2000);
    this.interval = interval;
  }

  protected onError() {
    console.error(`ERROR Connection to Server: ${this.server}`);
  }

  protected onMessage(evt: MessageEvent) { }

  //
  // Note: this function will work only if the following flag is set under chrome://flags
  // 'Anonymize local IPs exposed by WebRTC' flag should be DISABLED
  //
  private async ipLocal() {
    let ip = await new Promise((resolve, reject) => {
      let pc = new RTCPeerConnection();
      pc.createDataChannel('');
      pc.createOffer().then(offer => pc.setLocalDescription(offer));
      pc.onicecandidate = event => {
        if (event && event.candidate && event.candidate.candidate) {
          let s = event.candidate.candidate.split('\n');
          resolve(s[0].split(' ')[4]);
        }
        else {
          resolve('.local');
        }
        pc.close();
      };
    });
    return ip;
  }

}
